import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data } = useRequest({
    url: '/api/inspection/item?is_deleted=0',
    name: 'inspectionItemGet',
    method: 'GET'
  });
  return [data || [], isRequestSuccessed];
})